import { useNavigate } from 'react-router-dom';

export default function FAQSection() {
  const navigate = useNavigate();
  const faqs = [
    {
      q: "Cos'\u00e8 esattamente Itaobuy Spreadsheet?",
      a: "Itaobuy Spreadsheet \u00e8 uno strumento di organizzazione dati che raccoglie prodotti, categorie e informazioni in formato strutturato, permettendo agli utenti di navigare e confrontare facilmente migliaia di articoli senza dover effettuare ricerche manuali. \u00c8 particolarmente utile per chi cerca un accesso rapido a prodotti selezionati con informazioni gi\u00e0 verificate.",
    },
    {
      q: "Come posso utilizzare Itaobuy Spreadsheet?",
      a: "Puoi accedere alle categorie dal menu a tendina in alto o dai pulsanti nella sezione categorie. Ogni categoria ti porta a una pagina dedicata con prodotti selezionati. Puoi sfogliare, confrontare prezzi e caratteristiche, e prendere decisioni di acquisto pi\u00f9 informate.",
    },
    {
      q: "Itaobuy Spreadsheet \u00e8 gratuito?",
      a: "S\u00ec, l'accesso a Itaobuy Spreadsheet \u00e8 completamente gratuito. Puoi esplorare tutte le categorie e i prodotti senza costi. La piattaforma \u00e8 stata creata per fornire uno strumento di supporto accessibile a tutti gli utenti italiani.",
    },
    {
      q: "Quante categorie di prodotti ci sono?",
      a: "Attualmente Itaobuy Spreadsheet copre 14 categorie principali, tra cui Scarpe, Felpe, T-Shirt, Giacche, Pantaloni, Accessori, Borse, Profumi e molto altro. Ogni categoria viene regolarmente aggiornata con nuovi prodotti.",
    },
    {
      q: "Le informazioni sono aggiornate?",
      a: "S\u00ec, Itaobuy Spreadsheet viene aggiornato regolarmente. La nostra guida \u00e8 aggiornata al 2026 e include le informazioni pi\u00f9 recenti su prodotti, categorie e tendenze. Consigliamo sempre di verificare i dettagli specifici prima dell'acquisto.",
    },
  ];

  return (
    <section id="faq" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-background-100 border border-background-200 mb-6">
            <span className="text-foreground-600 text-sm font-semibold">FAQ</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Domande Frequenti
          </h2>
          <p className="text-foreground-500 text-base max-w-[500px] mx-auto">
            Le risposte alle domande pi&ugrave; comuni su <strong>itaobuy spreadsheet</strong>.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-white rounded-2xl border border-background-200 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                <span className="font-semibold text-foreground-950 text-base pr-4">{faq.q}</span>
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-100 group-open:bg-accent-100 transition-colors">
                  <i className="ri-add-line text-foreground-500 group-open:hidden"></i>
                  <i className="ri-subtract-line text-accent-600 hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/articolo-guida-itaobuy-spreadsheet')}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-700 font-medium text-sm hover:bg-background-200 transition-colors cursor-pointer"
          >
            Leggi la guida completa
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}